<template>
  <section :key="selectedOtherTeaors">
    <label style="padding: 0" for="selectedOtherTeaors">{{ title || 'Válasszon további tevékenységi köröket' }} </label>
    <div v-for="teaorCode in selectedOtherTeaors" v-bind:key="teaorCode.id" class="d-flex row">
      <TeaorSelector
        @selected-teaor="onTeaorCodeChange(teaorCode.id, $event)"
        :disabled="disabled"
        :listType="listType"
        :alreadySelected="teaorCode.teaorCode"
        :class="`col-11 ${teaorCode.id !== '0' ? 'mt-3' : ''} `"
      />
      <div
        v-if="!disabled"
        class="col-1 d-flex align-items-center justify-content-end"
        style="padding: 0px; height: 48px;"
      >
        <font-awesome-icon
          icon="fa-solid fa-trash"
          class="cursor-pointer mt-4 mr-3 mr-sm-2"
          @click="deleteTeaorCode(teaorCode.id)"
        />
      </div>
    </div>
    <p class="cursor-pointer mt-5" @click="addExtraTeaorCode">
      <strong class="add-more">+ További tevékenységi körök hozzáadása </strong>
    </p>
  </section>
</template>

<script>
import TeaorSelector from '../../../components/TeaorSelector/TeaorSelector.vue'
import errorToast from '../../../mixins/toastError'
export default {
  mixins: [errorToast],
  props: {
    title: { type: String },
    disabled: { type: Boolean },
    listType: { type: String },
    alreadySelected: { type: Array },
    maximumExtraFieldRule: { type: Number, default: 100 }
  },
  data() {
    return {
      selectedOtherTeaors: [{ id: '0', teaorCode: '' }]
    }
  },
  components: { TeaorSelector },
  methods: {
    onTeaorCodeChange(id, value) {
      const newAr = this.selectedOtherTeaors
        .map(teaorCode => {
          if (teaorCode.id === id) {
            return { id, teaorCode: value }
          }
          return teaorCode
        })
        .filter(x => x !== undefined)
      this.selectedOtherTeaors = newAr
    },
    addExtraTeaorCode() {
      if (!this.disabled && this.selectedOtherTeaors.length < this.maximumExtraFieldRule) {
        let newItem = {
          id: (Number(this.selectedOtherTeaors[this.selectedOtherTeaors.length - 1].id) + 1).toString(),
          teaorCode: ''
        }
        this.selectedOtherTeaors.push(newItem)
      } else {
        this.errorToast('Elérte a maximálisan rögzíthető tevékenységek / telephelyek számát!')
      }
    },
    deleteTeaorCode(id) {
      if (id === '0') {
        return (this.selectedOtherTeaors = [{ id: '0', teaorCode: '' }])
      }
      const newAr = this.selectedOtherTeaors
        .map(teaorCode => {
          if (teaorCode.id === id) {
            return
          }
          return teaorCode
        })
        .filter(x => x !== undefined)
      this.selectedOtherTeaors = newAr
    }
  },
  watch: {
    selectedOtherTeaors: {
      handler(value) {
        if (value[0].teaorCode !== '') {
          this.$emit('selected-other-teaors', value)
        } else {
          this.$emit('selected-other-teaors', [])
        }
      },
      deep: true
    },
    disabled: function() {
      this.selectedOtherTeaors = [{ id: '0', teaorCode: '' }]
    }
  },
  created() {
    if (this.alreadySelected.length > 0 && !this.disabled) {
      this.selectedOtherTeaors = this.alreadySelected
    }
  }
}
</script>

<style lang="scss" scoped>
.add-more {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #00903c;
  cursor: pointer;
  display: flex;
  justify-content: end;
}
</style>
